import React from 'react'
import { SlotComponent } from '../../../types/ui'
import { TextSizeOrSpacing } from '../../../types/cms'
import { CmsImage } from '../cms-image'
import { Box, Stack, Text, useDisclosure } from '../../../vanilla'
import { competitionEntryBanner, competitionEntryBannerBackground } from './style.css'
import { getBackgroundImages } from '../utils'
import { Markdown } from '../Markdown'
import { CompetitionMarketingForm } from '../competition-marketing-form'
import { Sprinkles } from '../../../vanilla/sprinkles.css'
import { CompetitionEntryBannerProps } from '../../../types/cms/competition-entry-banner'
import { getPositionX, getBackgroundSize, getLogoAlignment, getPositionY, getTextAlignment, getSpacing } from '../../../utils/cms/competition-entry-banner-utils'

export const CompetitionEntryBanner: SlotComponent<
    CompetitionEntryBannerProps
> = ({ content }) => {
    const marketingFormModal = useDisclosure(false)
    const { competitionBanner, competitionInfo, marketingForm } = content
    const { desktopURL, tabletURL, mobileURL } = getBackgroundImages(competitionBanner?.backgroundImage?.images || [])

    return (
        <Stack>
            <Box className={`${competitionEntryBanner}`} paddingX={['0px', '20px']}>

                {/* Background image */}
                <Box gridColumn={['1', getBackgroundSize(competitionBanner?.backgroundSize || '')]} gridRow={[getBackgroundSize(competitionBanner?.backgroundSizeMobile || ''), '1']} position={'relative'} height={'full'} style={{ margin: '0 -20px' }}>

                    <Box
                        className={competitionEntryBannerBackground}
                        style={{
                            ...(competitionBanner?.useImage ? {
                                '--background-image-mobile': `url(${mobileURL})`,
                                '--background-image-tablet': `url(${tabletURL})`,
                                '--background-image-desktop': `url(${desktopURL})`
                            } : {
                                    backgroundColor: competitionBanner?.bannerColour?.color || '#fff'
                            })
                        } as unknown as React.CSSProperties }
                    >
                    </Box>
                </Box>

                {/* Title and Description */}
                <Box
                    gap={getSpacing(competitionInfo?.textSpacing)}
                    height={'full'}
                    zIndex={'1'}
                    paddingX='10px'
                    paddingY={['20px', '0px']}
                    gridColumn={['1', getPositionX('stretch', marketingForm), getPositionX(competitionInfo?.positionX, marketingForm)] as Sprinkles['gridColumn']}
                    gridRow={['1 / span 2', '1']}
                    display={'flex'}
                    flexDirection={'column'}
                    justifyContent={['flex-end', getPositionY(competitionInfo.positionY)]}
                    alignItems={['center', 'flex-start']}
                    style={{ color: competitionInfo?.textColour?.color || '#ffff' }}
                >
                    <Box 
                        display={'flex'}
                        gap={getSpacing(competitionInfo?.textSpacing)}
                        justifyContent={'flex-end'}
                        flexDirection={'column'}
                        alignItems={['center', 'flex-start']}
                        textAlign={'center'}
                        paddingY={'4px'}
                    >
                        {typeof competitionInfo?.logo !== 'undefined' && (
                            <Box alignSelf={getLogoAlignment(competitionInfo?.logoAlignment)}>
                                <CmsImage
                                    queryParams={[
                                        { h: 70, fmt: 'auto', qlt: 'default' },
                                    ]}
                                    images={competitionInfo.logo?.images || []} />
                            </Box>
                        )}
                        
                        <Text
                            variant={
                                competitionInfo.titleSize === TextSizeOrSpacing.SMALL
                                    ? 'heading3'
                                    : competitionInfo.titleSize === TextSizeOrSpacing.MEDIUM
                                        ? 'heading4'
                                        : competitionInfo.titleSize === TextSizeOrSpacing.LARGE
                                            ? 'heading7'
                                            : 'heading5'
                            }
                            lineHeight={'taller'}
                            textAlign={[getTextAlignment(competitionInfo?.positionX), 'left']}
                        >
                            {competitionInfo?.title}
                        </Text>
                        <Box display={'flex'} flexDirection={'column'} gap={getSpacing(competitionInfo?.textSpacing)} textAlign={'center'} >
                            <Markdown markdown={competitionInfo?.description || ''}
                                componentProps={{
                                    p: {
                                        variant: competitionInfo.descriptionSize === TextSizeOrSpacing.SMALL
                                    ? 'text2'
                                    : competitionInfo.descriptionSize === TextSizeOrSpacing.MEDIUM
                                        ? 'text6'
                                        : competitionInfo.descriptionSize === TextSizeOrSpacing.LARGE
                                            ? 'heading1'
                                            : 'text6',
                                        textAlign: [getTextAlignment(competitionInfo?.positionX), 'left']
                                    },
                                    a: {
                                        color: 'inherit',
                                        textDecoration: 'underline',   
                                    }
                                }}
                            />
                        </Box>
                    </Box>
                </Box>
                {/* Marketing form */}
                {marketingForm?.includeMarketingForm &&
                    <CompetitionMarketingForm
                        content={marketingForm?.marketingform?.[0] || {}}
                        zIndex={'1'}
                        gridColumn={['1', getPositionX(marketingForm?.formPosition, marketingForm)]}
                        gridRow={['3', '1']}
                        marginX={['0px', '10px']}
                        padding={'0px'}
                        isModal={false}
                        height={['auto', '400px']}
                        overflow={'auto'}
                        width={['full', '400px']}
                        formType='Banner'
                        {...marketingFormModal}
                    />
                }
            </Box>
        </Stack>
    )
}